import script from "./datatable.vue?vue&type=script&lang=ts&setup=true"
export * from "./datatable.vue?vue&type=script&lang=ts&setup=true"

import "./datatable.vue?vue&type=style&index=0&id=05adf29a&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-05adf29a"]])

export default __exports__